module.exports = __webpack_public_path__ + "87bec24442f0915f4298f3d7d7e18b55.svg";